import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import * as staticsApi from '../../lib/api/statics';
import { salesHeaders } from '../../utils/forecastStaticData';
import SalesStaticsEmpTable from '../../components/sales-statics/SalesStaticsEmpTable';

const SalesStaticsEmployeeContainer = ({
  year,
  startMonth,
  endMonth,
  searchDate,
  tableRef,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();

  const onLoadData = async () => {
    setLoading(true);

    try {
      const res = await staticsApi.getEmpSalesStatics(
        year,
        startMonth,
        endMonth,
      );

      if (res.data.list) {
        setData(res.data.list);
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (searchDate) {
      onLoadData();
    }
  }, [searchDate]);

  return (
    <SalesStaticsEmpTable
      data={data}
      loading={loading}
      headerRows={salesHeaders}
      tableRef={tableRef}
    />
  );
};

export default SalesStaticsEmployeeContainer;
